module.exports = __webpack_public_path__ + "static/img/1.9fe3e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/temp/1.png
// module id = 8NvK
// module chunks = 1